
import { saveEverything } from "../actions/globalActions";
import { eventCategories, recordEvent } from "../utils/googleAnalyticsEvents";
import { useAppDispatch } from "../hooks";

/**
 * This hook provides the caller with everything it needs to save the layout.
 */
export const useSaveWrapper = () => {
  const dispatch = useAppDispatch();
  const onSaveClick = () => {
    recordEvent(
      "Save Layout",
      eventCategories.GENERAL_APP_ACTION,
      "Save Layout"
    );
    dispatch(saveEverything());
  };

  return { onSaveClick };
};
